import { Navigate, Outlet } from "react-router-dom";

export const ExistingProfile = ({ existing = false}) => {
  return !existing ? <Outlet /> : <Navigate replace to="./wait-approval" />;
};
export default ExistingProfile;
